
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// const bootstrap = require('bootstrap');
// require('bootstrap')
import 'bootstrap';
import './bootstrap';
// import '../sass/app.scss';

import 'jquery';
import './datatables/jquery.dataTables.min.js';
import './datatables/dataTables.bootstrap5.min.js';
import './datatables/dataTables.bootstrap5.min.css';
import './datatables/dataTables.rowshow.js';

const datatableLanguages = {
    'de' : {
        processing:     "",
        search:         "Suchen&nbsp;:",
        lengthMenu:     "Zeige _MENU_ Einträge",
        info:           "Zeige _START_ bis _END_ von _TOTAL_ Einträgen",
        infoEmpty:      "Zeige 0 bis 0 von 0 Einträgen",
        infoFiltered:   "(gefiltert von _MAX_ Einträgen)",
        infoPostFix:    "",
        loadingRecords: "Laden...",
        zeroRecords:    "Keine passenden Einträge gefunden",
        emptyTable:     "Keine Daten in der Tabelle verfügbar",
        paginate: {
            first:      "Erste",
            previous:   "Vorherige",
            next:       "Nächste",
            last:       "Letzte"
        },
        aria: {
            sortAscending: ": aktivieren, um Spalte aufsteigend zu sortieren",
            sortDescending: ": aktivieren, um Spalte absteigend zu sortieren"
        }
    },
    'en' : { }
}

$('.datatable').DataTable({
    language: datatableLanguages[schein_app_locale]
});

$('input[type="number"][min]').on('change', function() {
    let min = parseInt($(this).attr('min'));
    if ($(this).val() == 0) {
        $(this).val('');
        return;
    }
    if ($(this).val() < min) {
        $(this).val(min);
    }
});